// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Security } from "@okta/okta-react";
import { OktaAuth } from "@okta/okta-auth-js";
import App from "./App";
import oktaConfig from "./config/oktaConfig";
import "./index.css";


const oktaAuth = new OktaAuth(oktaConfig);

oktaAuth.authStateManager.subscribe(state =>
  console.log("index.js : authState changed:", state)
);

oktaAuth.start().then( () => {
  console.log("index.js : OktaAuth started successfully");
}).catch( err => {
  console.error("index.js : OktaAuth start error : ", err);
});

const restoreOriginalUri = async (_oktaAuth, originalUri) => {
  console.log("Restoring to URI : ", originalUri || "/");
  window.location.replace(originalUri || "/");
}

const CustomError = ({ error }) => (
  <div>
    <h1>Authentication Error</h1>
    <p>{error?.message || "An error occurred during login. Please try again." }</p>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <App />
    </Security>
  </BrowserRouter>
);